import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '@/services/CredentialsService.js'

const HorseshoeRepository = RepositoryFactory.get('horseshoe')

class HorseshoeService {
  static async createHorseshoe (data) {
    try {
      return await HorseshoeRepository.createHorseshoe(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
    }
  }

  static async updateHorseshoe (horseshoeId, data) {
    try {
      return await HorseshoeRepository.updateHorseshoe(CredentialsService.getCurrentTenantId(), horseshoeId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async deleteHorseshoe (horseshoeId) {
    try {
      return await HorseshoeRepository.deleteHorseshoe(CredentialsService.getCurrentTenantId(), horseshoeId)
    } catch (error) {
      console.log(error)
    }
  }
}

export default HorseshoeService
